import Vue from 'vue';
import App from './App.vue';
import router from './router';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import store from './store'
import 'lib-flexible';
import '../src/utils/rem'; //在main.js中引入rem.js

// 导入i18n
import i18n from './i18n/i18n';
Vue.use(ElementUI);
Vue.config.productionTip = false
new Vue({
  el: '#app',
  router,
  i18n, // 这里记得也要加上
  store,
  render: h => h(App)
});